import { render, staticRenderFns } from "./suppliers-map.vue?vue&type=template&id=50e34d86"
import script from "./suppliers-map.vue?vue&type=script&lang=js"
export * from "./suppliers-map.vue?vue&type=script&lang=js"
import style0 from "./suppliers-map.vue?vue&type=style&index=0&id=50e34d86&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e34d86')) {
      api.createRecord('50e34d86', component.options)
    } else {
      api.reload('50e34d86', component.options)
    }
    module.hot.accept("./suppliers-map.vue?vue&type=template&id=50e34d86", function () {
      api.rerender('50e34d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/map/suppliers-map.vue"
export default component.exports